import Cloud from "../../modules/cloud/cloud-layout"
import HomeCloud from "@/modules/cloud/component/Home"
import ClientsCloud from "@/modules/cloud/component/Clients"

const CloudRouter = {
	path: "/cloud",
	name: "cloud",
	component: Cloud,
	children: [
		{
			path: "",
			name: "cloud",
			component: HomeCloud,
			props: true
		},
		{
			path: "clients",
			name: "clients-cloud",
			component: ClientsCloud,
			props: true
		}
	]
}

export default CloudRouter
